// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__jdwlc","profilePhoto":"styles_profilePhoto__dXlEJ","name":"styles_name__uX25A","role":"styles_role__9lmAm"};